
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/contact",
      function () {
        return require("private-next-pages/[hid]/contact/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/contact"])
      });
    }
  